import React from 'react';
import Loadable from 'react-loadable';
import { Loading } from '@stormideas/react-sdk';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading visible />,
});

export const Form = Loadable({
  loader: () => import('./containers/FormPage'),
  loading: () => <Loading visible />,
});

export const ForgotPassword = Loadable({
  loader: () => import('./containers/ForgotPasswordPage'),
  loading: () => <Loading visible />,
});

export const ResetPassword = Loadable({
  loader: () => import('./containers/ResetPasswordPage'),
  loading: () => <Loading visible />,
});
